import { useAppSelector } from "@/redux/store/hooks";

export function useIsPrivatePlacesMediaBucketEnabled(): boolean {
  const { features } = useAppSelector((state) => state.features);
  return Boolean(features?.enablePrivateBucketForPlaces?.enabled);
}
